import React, { useCallback, useLayoutEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Controller, useForm } from "react-hook-form";
import { selectLoginError, selectLoginLoading, signIn } from "features/authentication/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "store/rootReducer";
import { DefaultText } from "theme/GlobalElements";
import Preloader from "components/Preloader/Preloader";
import { setBreadcrumbTitle } from "features/breadcrumb/breadcrumbSlice";

const useStyles = makeStyles((theme) => ({
  paper: {
    minHeight: "100vh",
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Login = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isLoading = useSelector((state: RootState) => selectLoginLoading(state));

  const error = useSelector((state: RootState) => selectLoginError(state));
  const { handleSubmit, control } = useForm();

  const callback = useCallback(() => {
    navigate("/orders");
  }, []);
  const onSubmit = (data: any) => {
    dispatch(signIn(data.username, data.password, callback));
  };

  useLayoutEffect(() => {
    dispatch(setBreadcrumbTitle(""));
  }, [dispatch]);
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}></Avatar>
        <Typography component="h1" variant="h5">
          Вход
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
          <Controller
            as={TextField}
            control={control}
            defaultValue=""
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Потребителско име"
            name="username"
            autoComplete="name"
            autoFocus
          />
          <Controller
            as={TextField}
            control={control}
            defaultValue=""
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Парола"
            type="password"
            id="password"
            autoComplete="current-password"
          />

          <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
            Вход
          </Button>
        </form>
        {isLoading && <Preloader />}

        {error && (
          <DefaultText fontSize={14} color="red">
            {error}
          </DefaultText>
        )}
      </div>
    </Container>
  );
};

export default Login;
